import { AlertsConfig } from '../../../types'
import { ListType } from '../../constants/enums'
import {
    subscribeWorkerAlertsUpdates,
    subscribeWorkerListUpdates,
    subscribeWorkerUserUpdates,
    unsubscribeWorkerAlertsUpdates,
    unsubscribeWorkerListUpdates,
    unsubscribeWorkerUserUpdates,
} from './workerSubscriptions'

export const alertsInterceptors = {
    on: (key: ListType, config: AlertsConfig) => {
        if (!key) return
        subscribeWorkerAlertsUpdates(config)
    },
    off: (key: ListType, config: AlertsConfig) => {
        if (!key) return
        unsubscribeWorkerAlertsUpdates(config)
    },
}

export const listInterceptors = {
    on: (key: ListType) => {
        if (!key) return
        subscribeWorkerListUpdates(key)
    },
    off: (key: ListType) => {
        if (!key) return
        unsubscribeWorkerListUpdates(key)
    },
}

export const userInterceptors = {
    on: (key: string) => {
        const id = extractId(key)
        if (!id) return
        subscribeWorkerUserUpdates(id)
    },
    off: (key: string) => {
        const id = extractId(key)
        if (!id) return
        unsubscribeWorkerUserUpdates(id)
    },
}

function extractId(key: string) {
    if (!key.startsWith('UPDATE::')) return
    const [, idStr] = key.split('::')
    return Number(idStr)
}
